<template>
  <div class="container mescroll-touch">
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="banner">
        <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="#333333">
          <van-swipe-item>
            <img class="banner-img" :src="baseURL + details.ImgUrl" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="square_consult">
          <div class="square_consult_title">热点快讯</div>
          <div class="square_tab_scroll" ref="wrapper" v-if="details.ChildSubject && details.ChildSubject.length > 0">
            <div class="square_tab_wrapper">
              <span :class="{ 'active': SubjectTCode == tcode }" @click="changeTab(tcode)">全部</span>
              <span :class="{ 'active': SubjectTCode == item.TCode }" v-for="(item, index) in details.ChildSubject" :key="index" @click="changeTab(item.TCode)">{{ item.Title }}</span>
            </div>
          </div>
          <div class="square_consult_box">
            <div class="right_Consult" v-for="(item, index) in list" :key="index" @click="toDetail(item)">
              <div class="base">
                <div class="title van-multi-ellipsis--l2">
                  <span class="top" v-if="item.IsTop">置顶</span>{{ item.Title }}
                </div>
                <div class="info">
                  <div class="source_box">
                    <img class="source_icon" v-if="item.SourceImg" :src="baseURL + item.SourceImg" />
                    <span class="source_title van-ellipsis" v-if="item.Source">{{ item.Source }}</span>
                  </div>
                  <span class="time" v-if="item.PublishDate">{{ item.PublishDate.split(' ')[0] }}</span>
                </div>
              </div>
              <div class="picture">
                <img :src="baseURL + item.Img" />
              </div>
            </div>
          </div>
        </div>
    </mescroll-vue>
    <img class="share" src="../../assets/images/circle_share.png" @click="showSharePanel = true" />
    <SharePanel :show="showSharePanel" @close="closeSharePanel" />
  </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import SharePanel from '@/components/sharePanel.vue'
export default {
  name: 'HotspotInformation',
  data() {
    return {
      baseURL: process.env.VUE_APP_BASE_URL,
      details: {},
      SubjectTCode: '',
      list: [],
      PageIndex: 0,
      PageSize: 10,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 10 //每页数据条数,默认10
				},
        noMoreSize: 0,
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_comm_icon@2x.png' // 回到顶部按钮的图片路径,支持网络图
        }
			},
      showSharePanel: false
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    SharePanel
  },
  computed: {
    code() {
      return this.$route.query.code;
    },
    tcode() {
      return this.$route.query.tcode;
    },
  },
  watch: {
    SubjectTCode() {
      this.list = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
  },
  created() {
    document.title = "华肤荟";
    if(this.code) {
      this.getColumn();
    }

    if(this.tcode) {
      this.SubjectTCode = this.tcode;
    }
  },
  methods: {
    initBScroll() {
      this.$nextTick(() => {
        this.scroll = new BScroll(this.$refs['wrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    getColumn() {
      this.$axios.get(`/api/api/web/content/SubjectDetail?code=${this.code}`).then(res => {
        this.details = res.Data;
        this.initBScroll();
        this.initShare(this.details.Title);
      })
    },
    changeTab(tcode) {
      this.SubjectTCode = tcode;
    },
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      this.$axios.post('/api/api/web/content/SubjectArticleList', {
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        TCode: this.SubjectTCode
      }).then(res => {
        if (PageIndex === 1) this.list = []
        this.list = this.list.concat(res.Data.List);
        this.$nextTick(() => {
          this.mescroll.endSuccess(res.Data.List.length)
        })
      })
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
		},
    // 上拉回调
		upCallback (page) {
      this.getList(page.num, page.size);
		},
    toDetail(info) {
      console.log('跳转详情')
      if(info.isOuterChain) {
        location.href = info.outerChain;
      } else {
        this.$router.push({
          path: 'informationDetails',
          query: {
            code: info.Code
          }
        });
      }
    },
    closeSharePanel() {
      this.showSharePanel = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  background-color: #f7f8fc;
  padding: 12px;
  box-sizing: border-box;
  .banner {
    .banner-swipe {
      .banner-img {
        display: block;
        width: 100%;
      }
    }
  }
  .square_consult {
    .square_consult_title {
      color: #1f2b5b;
      font-size: 18px;
      font-weight: 600;
      margin: 15px 0 10px;
    }
    .square_tab_scroll {
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      margin-bottom: 8px;
      margin-top: -6px;
      padding: 6px 0;
      .square_tab_wrapper {
        white-space: nowrap;
      }
      span {
        position: relative;
        color: #435361;
        font-size: 16px;
      }
      span:not(:first-of-type) {
        margin-left: 20px;
      }
      .active {
        color: #1D2A5A;
      }
      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -6px;
        transform: translateX(-16px);
        width: 32px;
        height: 3px;
        border-radius: 3px;
        background: #1f2b5b;
      }
    }
    /* 隐藏水平滚动条 */
    .square_tab_scroll::-webkit-scrollbar {
      display: none;
    }
    .square_consult_box {
      .right_Consult {
        display: flex;
        border-radius: 8px;
        box-shadow: 0 5px 8px 0 rgba(0,0,0,.04);
        margin-bottom: 10px;
        padding: 10px;
        background-color: #FFFFFF;
        box-sizing: border-box;
        .base {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          .title {
            color: #0c2941;
            font-size: 15px;
            font-weight: 500;
            line-height: 22px;
            .top {
              background: #1f2b5b;
              border-radius: 2px;
              font-size: 12px;
              color: #fff;
              padding: 3px;
              margin-right: 5px;
            }
          }
          .info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .source_box {
              display: flex;
              align-items: center;
              min-width: 25px;
              max-width: 70%;
              height: 25px;
              border-radius: 25px;
              background: #f6f6f6;
              .source_icon {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                margin: 0 5px;
                background-color: #fff;
              }
              .source_title {
                font-size: 12px;
                color: #435361;
                margin: 0 10px 0 5px;
              }
            }
            .time {
              font-size: 12px;
              color: #435361;
            }
          }
        }
        .picture {
          flex-shrink: 0;
          width: 80px;
          height: 80px;
          border-radius: 10px;
          overflow: hidden;
          margin-left: 10px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .share {
    position: fixed;
    right: 10px;
    bottom: 120px;
    width: 40px;
    height: 40px;
    z-index: 100;
  }
}
</style>